import { render, staticRenderFns } from "./ActaSeguimiento.vue?vue&type=template&id=5f349b9c&"
import script from "./ActaSeguimiento.vue?vue&type=script&lang=js&"
export * from "./ActaSeguimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports